import { $ } from "@/plug/Axios";

export default {
  /**
   * 教材邮寄
   */
  mail_downloadMould: {
    /*
     * 下载模板
     */
    get: (p, c) => $.get("/api/ems/textbook/mail/downloadMould", p, c)
  },
  mail_list: {
    /*
     * 列表-学历教育-教材管理-成教教材邮寄
     */
    get: (p, c) => $.get("/api/ems/textbook/mail/list", p, c)
  },
  mail_listForSelfTaught: {
    /*
     * 列表-自考平台-教材管理-教材邮寄
     */
    get: (p, c) => $.get("/api/ems/textbook/mail/listForSelfTaught", p, c)
  },
  mail_listSimple: {
    /*
     * 简易邮寄名称列表
     */
    get: (p, c) => $.get("/api/ems/textbook/mail/listSimple", p, c)
  },
  mail_publish: {
    /*
     * 发布
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/textbook/mail/publish", p, c)
  },
  mail_refresh: {
    /*
     * 刷新教材数据
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/ems/textbook/mail/refresh", p, c)
  },
  mail_remove: {
    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/textbook/mail/remove", p, c)
  },
  mail_removeMember: {
    /*
     * 删除邮寄人员
     * id 邮寄人员列表返回的id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/textbook/mail/removeMember", p, c)
  },
  mail_save: {
    /*
     * 添加邮寄
     * deadline 学生确认截止时间 (string query required)
     * name 邮寄名称 (string query required)
     * resendDeadline 补寄截止时间 (string query required)
     * rollGrade 学籍年级 (string query required)
     * siteId 学校id (integer query required)
     * term 学期 (integer query required)
     */
    post: (p, c) => $.post("/api/ems/textbook/mail/save", p, c)
  },
  mail_update: {
    /*
     * 编辑
     * deadline 截止时间 (string query required)
     * id id (integer query required)
     * name 邮寄名称 (string query required)
     * resendDeadline 补寄截止时间 (string query required)
     */
    put: (p, c) => $.put("/api/ems/textbook/mail/update", p, c)
  },
  mail_upload: {
    /*
     * 导入邮寄人员
     * excelFile excelFile (file formData required)
     * id id (integer query required)
     */
    post: (p, c) => $.post("/api/ems/textbook/mail/upload", p, c)
  },

  /**
   * 教材邮寄详情
   */
  record_commitForClient: {
    /*
     * c端确认
     * confirmStatus 确认状态:需要教材|不需要教材 (string query required)
     * id id (integer query required)
     * recipientAddress 收件人地址 (string query )
     * recipientName 收件人 (string query )
     * recipientPhone 收件人电话 (string query )
     */
    post: (p, c) => $.post("/api/ems/textbook/record/commitForClient", p, c)
  },
  record_commitForSelfTaughtClient: {
    /*
     * c端确认-自考
     * confirmStatus 确认状态:需要教材|不需要教材 (string query required)
     * id id (integer query required)
     * recipientAddress 收件人地址 (string query )
     * recipientName 收件人 (string query )
     * recipientPhone 收件人电话 (string query )
     */
    post: (p, c) =>
      $.post("/api/ems/textbook/record/commitForSelfTaughtClient", p, c)
  },
  record_commitForService: {
    /*
     * 编辑学生邮寄信息-班主任
     * confirmStatus 确认状态:需要教材|不需要教材 (string query required)
     * id id (integer query required)
     * recipientAddress 收件人地址 (string query )
     * recipientName 收件人 (string query )
     * recipientPhone 收件人电话 (string query )
     */
    post: (p, c) => $.post("/api/ems/textbook/record/commitForService", p, c)
  },
  record_detail: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/textbook/record/detail", p, c)
  },
  record_downloadMould: {
    /*
     * 下载导入快递单号模板
     */
    get: (p, c) => $.get("/api/ems/textbook/record/downloadMould", p, c)
  },
  record_export: {
    /*
     * 导出-学历教育-教材管理-成教教材邮寄详情
     */
    get: (p, c) => $.get("/api/ems/textbook/record/export", p, c)
  },
  record_exportForSelfTaught: {
    /*
     * 导出-自考平台-教材管理-成教教材邮寄详情
     */
    get: (p, c) => $.get("/api/ems/textbook/record/exportForSelfTaught", p, c)
  },
  record_exportForSeller: {
    /*
     * 导出(书商)-学历教育-教材管理-成教教材邮寄详情
     */
    get: (p, c) => $.get("/api/ems/textbook/record/exportForSeller", p, c)
  },
  record_exportForSellerForSelfTaught: {
    /*
     * 导出(书商)-自考平台-教材管理-成教教材邮寄详情
     */
    get: (p, c) =>
      $.get("/api/ems/textbook/record/exportForSellerForSelfTaught", p, c)
  },
  record_exportForService: {
    /*
     * 导出-学历教育-服务管理-成教教材邮寄详情
     */
    get: (p, c) => $.get("/api/ems/textbook/record/exportForService", p, c)
  },
  record_exportForServiceForSelfTaught: {
    /*
     * 导出-自考平台-服务管理-成教教材邮寄详情
     */
    get: (p, c) =>
      $.get("/api/ems/textbook/record/exportForServiceForSelfTaught", p, c)
  },
  record_exportForServiceUpload: {
    /*
     * 导出未确认和无需教材学生-学历教育-服务管理-成教教材邮寄详情
     */
    get: (p, c) =>
      $.get("/api/ems/textbook/record/exportForServiceUpload", p, c)
  },
  record_getExpressInfoForClient: {
    /*
     * 查询快递信息
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/textbook/record/getExpressInfoForClient", p, c)
  },
  record_list: {
    /*
     * 列表-学历教育-教材管理-成教教材邮寄详情
     */
    get: (p, c) => $.get("/api/ems/textbook/record/list", p, c)
  },
  record_listForClient: {
    /*
     * 我的邮寄记录
     */
    get: (p, c) => $.get("/api/ems/textbook/record/listForClient", p, c)
  },
  record_listForSelfTaught: {
    /*
     * 列表-学历教育-教材管理-成教教材邮寄详情
     */
    get: (p, c) => $.get("/api/ems/textbook/record/listForSelfTaught", p, c)
  },
  record_listForService: {
    /*
     * 列表-学历教育-服务管理-成教教材邮详情
     */
    get: (p, c) => $.get("/api/ems/textbook/record/listForService", p, c)
  },
  record_listForServiceForSelfTaught: {
    /*
     * 列表-自考平台-服务管理-教材邮寄
     */
    get: (p, c) =>
      $.get("/api/ems/textbook/record/listForServiceForSelfTaught", p, c)
  },
  record_searchForClient: {
    /*
     * c端扫码获取信息
     */
    get: (p, c) => $.get("/api/ems/textbook/record/searchForClient", p, c)
  },
  record_searchForSelfTaughtClient: {
    /*
     * c端扫码获取信息
     */
    get: (p, c) =>
      $.get("/api/ems/textbook/record/searchForSelfTaughtClient", p, c)
  },
  record_uploadMailInfo: {
    /*
     * 导入学生邮寄信息-班主任用
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/textbook/record/uploadMailInfo", p, c)
  },
  record_uploadMailNo: {
    /*
     * 导入快递单号
     * excelFile excelFile (file formData required)
     */
    post: (p, c) => $.post("/api/ems/textbook/record/uploadMailNo", p, c)
  }
};
